import { render, staticRenderFns } from "./CandidateAssessmentsIndex.vue?vue&type=template&id=557d0274&scoped=true&"
import script from "./CandidateAssessmentsIndex.vue?vue&type=script&lang=ts&"
export * from "./CandidateAssessmentsIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d0274",
  null
  
)

export default component.exports